import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { api } from "../lib/api";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

const PROVINCES = ["ON", "QC", "BC", "AB", "MB", "SK", "NS", "NB", "NL", "PE"];

export default function WorkerOnboarding() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [form, setForm] = useState({
    headline: "",
    bio: "",
    category: "",
    skills: "",
    hourly_rate: 50,
    city: "",
    province: "ON",
    years_experience: 1,
    portfolio: "",
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/categories").then((r) => setCategories(r.data));
    api.get("/workers/me").then((r) => {
      if (r.data) {
        setForm({
          ...r.data,
          skills: (r.data.skills || []).join(", "),
          portfolio: (r.data.portfolio || []).join("\n"),
        });
      }
    });
  }, []);

  const onSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post("/workers/profile", {
        headline: form.headline,
        bio: form.bio,
        category: form.category,
        skills: form.skills.split(",").map((s) => s.trim()).filter(Boolean),
        hourly_rate: parseFloat(form.hourly_rate),
        city: form.city,
        province: form.province,
        years_experience: parseInt(form.years_experience) || 0,
        portfolio: form.portfolio.split("\n").map((s) => s.trim()).filter(Boolean),
      });
      toast.success("Profile saved");
      navigate("/dashboard");
    } catch (e) {
      toast.error("Could not save profile");
    } finally {
      setSaving(false);
    }
  };

  const update = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-24 pb-16 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 mb-2">Pro Onboarding</div>
        <h1 className="font-display text-4xl mb-8">Your Pro profile</h1>
        <form onSubmit={onSave} className="space-y-5">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 block mb-1">Headline</label>
            <input required value={form.headline} onChange={(e) => update("headline", e.target.value)} placeholder="e.g. Licensed Master Plumber, 10+ yrs" className="w-full border border-slate-300 px-3 py-2.5" data-testid="onboard-headline" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 block mb-1">About</label>
            <textarea required value={form.bio} onChange={(e) => update("bio", e.target.value)} rows={5} placeholder="Describe your services, experience, certifications…" className="w-full border border-slate-300 px-3 py-2.5" data-testid="onboard-bio" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 block mb-1">Category</label>
              <select required value={form.category} onChange={(e) => update("category", e.target.value)} className="w-full border border-slate-300 px-3 py-2.5" data-testid="onboard-category">
                <option value="">Select…</option>
                {categories.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 block mb-1">Hourly rate (CAD)</label>
              <input required type="number" min={1} value={form.hourly_rate} onChange={(e) => update("hourly_rate", e.target.value)} className="w-full border border-slate-300 px-3 py-2.5" data-testid="onboard-rate" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 block mb-1">City</label>
              <input required value={form.city} onChange={(e) => update("city", e.target.value)} placeholder="Toronto" className="w-full border border-slate-300 px-3 py-2.5" data-testid="onboard-city" />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 block mb-1">Province</label>
              <select value={form.province} onChange={(e) => update("province", e.target.value)} className="w-full border border-slate-300 px-3 py-2.5" data-testid="onboard-province">
                {PROVINCES.map((p) => <option key={p} value={p}>{p}</option>)}
              </select>
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 block mb-1">Years experience</label>
              <input type="number" min={0} value={form.years_experience} onChange={(e) => update("years_experience", e.target.value)} className="w-full border border-slate-300 px-3 py-2.5" data-testid="onboard-years" />
            </div>
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 block mb-1">Skills (comma separated)</label>
            <input value={form.skills} onChange={(e) => update("skills", e.target.value)} placeholder="leak repair, drain cleaning, water heater" className="w-full border border-slate-300 px-3 py-2.5" data-testid="onboard-skills" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.2em] font-semibold text-slate-500 block mb-1">Portfolio image URLs (one per line)</label>
            <textarea value={form.portfolio} onChange={(e) => update("portfolio", e.target.value)} rows={3} className="w-full border border-slate-300 px-3 py-2.5" data-testid="onboard-portfolio" />
          </div>
          <button type="submit" disabled={saving} className="bg-brand text-white px-6 py-3 font-semibold hover:bg-[#122148] disabled:opacity-50" data-testid="onboard-save-btn">
            {saving ? "Saving…" : "Save profile"}
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
}
